// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { flex } from 'styles';
import { BODY_ID } from 'Constants';

const Wrapper = styled.div`
  min-height: 100vh;
  ${flex()};
  flex-direction: column;
`;

const Body = ({ children, ...rest }: { children: Node }) => (
  <Wrapper id={BODY_ID} {...rest}>
    {children}
  </Wrapper>
);

export default Body;
